import {isValidElement} from 'react'
import {Layout, Title} from '~/components'

const PopoutHeaderLayout = ({children, ...rest}) => (
	<Layout className="popout-header" direction="vertical" width="full" {...rest}>
		{children}
	</Layout>
)

export const PopoutHeader = ({title, layoutProps, showContentBorders}) => {
	if (!title) return null

	const isElement = isValidElement(title)

	layoutProps = {
		borderBottom: showContentBorders,
		...layoutProps,
	}

	if (isElement) return <PopoutHeaderLayout {...layoutProps}>{title}</PopoutHeaderLayout>

	const textProps = _.isString(title) ? {t: title} : title
	const padding = showContentBorders ? '12' : '12 12 4'

	return (
		<PopoutHeaderLayout padding={padding} {...layoutProps}>
			<Title {...textProps} />
		</PopoutHeaderLayout>
	)
}
